import { createRoutine } from 'redux-saga-routines';
import { DO_LOGIN, DO_LOGOUT, DO_SOCIAL_LOGIN, GET_USER, DO_HR_LOGIN } from './actionTypes';

export const doLogin = createRoutine(DO_LOGIN);
export const getUser = createRoutine(GET_USER);
export const doLogout = createRoutine(DO_LOGOUT);
export const doSocialLogin = createRoutine(DO_SOCIAL_LOGIN);
export const doHRLogin = createRoutine(DO_HR_LOGIN);
